import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'green' | 'gold' | 'alert' | 'outline';
  className?: string;
}
const tones: Record<string, string> = {
  green: 'border-green/30 bg-green-soft text-green-deep',
  gold: 'border-gold/45 bg-gold/10 text-gold-deep',
  alert: 'border-alert/30 bg-alert-soft text-alert',
  outline: 'border-line bg-shell text-muted'
};
export function Pill({
  children,
  tone = 'green',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] ${tones[tone]} ${className}`} data-id="element-179" data-mp="1aypn8a2f9342">
      {children}
    </span>;
}